import type { ExtractPropTypes } from 'vue'

export type DialogTitlePosition = 'left' | 'center'

export const dialogProps = {
	closable: { type: Boolean, default: true },
	draggable: { type: Boolean, default: false },
	modelValue: Boolean,
	lazy: { type: Boolean, default: false },
	title: { type: String, default: '' },
	width: { type: [Number, String], default: '' },
	closeOnBlur: { type: Boolean, default: true },
	contentColor: { type: String, default: '' },
	global: { type: Boolean, default: true },
	slide: Boolean,
	mode: { type: String, default: '' },
	zIndex: { type: Number, default: 0 },
	beforeOpen: { type: Function, default: () => true },
	beforeClose: { type: Function, default: () => true },
	afterOpen: { type: Function, default: () => {} },
	afterClose: { type: Function, default: () => {} },
	flex: { type: Boolean, default: false }
}

export type DialogProps = ExtractPropTypes<typeof dialogProps>

export const dialogEmits = ['update:modelValue', 'beforeOpen', 'opened', 'beforeClose', 'closed', 'close-button-click']

export type DialogEmits = typeof dialogEmits
